import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const TITLE_SIZE_CLASS = {
  sm: "text-sm text-white font-semibold",
  lg: "text-lg text-white font-semibold"
};

const DESCRIPTION_SIZE_CLASS = {
  xs: "font-medium text-xs opacity-80 text-white",
  sm: "font-medium text-sm opacity-80 text-white"
};

const BannerCheckList = ({
  items,
  titleSize = "sm",
  descriptionSize = "xs"
}) => {
  const visibleItems = items.filter(
    ({ title, description, meta }) => title || description || meta
  );

  if (!visibleItems.length) {
    return null;
  }

  const titleClassName = TITLE_SIZE_CLASS[titleSize] || TITLE_SIZE_CLASS.sm;
  const descriptionClassName =
    DESCRIPTION_SIZE_CLASS[descriptionSize] || DESCRIPTION_SIZE_CLASS.xs;

  return (
    <ul className="ul-2_check">
      {visibleItems.map(({ key, title, description, meta }) => (
        <li key={key}>
          <div>
            {meta ? (
              <div className="flex gap-4 align-center mb-1">
                {title ? <span className={titleClassName}>{title}</span> : null}
                {meta}
              </div>
            ) : title ? (
              <span
                className={classNames(titleClassName, description && "block mb-1")}
              >
                {title}
              </span>
            ) : null}
            {description ? (
              React.isValidElement(description) ? (
                description
              ) : (
                <span className={descriptionClassName}>{description}</span>
              )
            ) : null}
          </div>
        </li>
      ))}
    </ul>
  );
};

BannerCheckList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.node,
      description: PropTypes.node,
      meta: PropTypes.node
    })
  ).isRequired,
  titleSize: PropTypes.oneOf(["sm", "lg"]),
  descriptionSize: PropTypes.oneOf(["xs", "sm"])
};

export default BannerCheckList;
